var _rect, _rect2, _g;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgAccession = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.300049,
    width: 65.625,
    height: 65.625,
    rx: 6.5625,
    fill: "#EBF6EB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1726_8711",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 13,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.425,
    y: 13.125,
    width: 39.375,
    height: 39.375,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1726_8711)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.1125 49.2187C30.843 49.2187 28.7102 48.7881 26.7141 47.9267C24.718 47.0654 22.9817 45.8965 21.5051 44.4199C20.0286 42.9433 18.8596 41.207 17.9983 39.2109C17.137 37.2148 16.7063 35.082 16.7063 32.8125C16.7063 30.5429 17.137 28.4101 17.9983 26.414C18.8596 24.4179 20.0286 22.6816 21.5051 21.205C22.9817 19.7285 24.718 18.5595 26.7141 17.6982C28.7102 16.8369 30.843 16.4062 33.1125 16.4062C35.3821 16.4062 37.5149 16.8369 39.511 17.6982C41.5071 18.5595 43.2434 19.7285 44.72 21.205C46.1965 22.6816 47.3655 24.4179 48.2268 26.414C49.0881 28.4101 49.5188 30.5429 49.5188 32.8125C49.5188 35.082 49.0881 37.2148 48.2268 39.2109C47.3655 41.207 46.1965 42.9433 44.72 44.4199C43.2434 45.8965 41.5071 47.0654 39.511 47.9267C37.5149 48.7881 35.3821 49.2187 33.1125 49.2187ZM33.1125 45.9375C36.7766 45.9375 39.8801 44.666 42.4231 42.123C44.9661 39.58 46.2375 36.4765 46.2375 32.8125C46.2375 31.0625 45.9094 29.3808 45.2532 27.7675C44.5969 26.1543 43.6536 24.7324 42.4231 23.5019L33.1125 32.8125V19.6875C29.4485 19.6875 26.345 20.959 23.802 23.5019C21.259 26.0449 19.9875 29.1484 19.9875 32.8125C19.9875 36.4765 21.259 39.58 23.802 42.123C26.345 44.666 29.4485 45.9375 33.1125 45.9375Z",
    fill: "#008908"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAccession, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/accession.c233ce27.svg";
export { ForwardRef as ReactComponent };